import { useContext } from 'react'
import { AppContext } from '../context'

export const useAppId = () => useContext(AppContext)
